// extracted by mini-css-extract-plugin
export default {"slideInFromLeft":"rJ8nO8u2qiqKHGPJiQYZ","slideInFromRight":"f1uhIGX0nXXFgHPlAJun","panelText":"u9vkLjIxlvT5aff9E3dQ"};